import { ConsultantLocatorErrorType } from '@core/enums/consultant-locator-error-type.enum';

export const ConsultantLocatorErrorMessage = {
  [ConsultantLocatorErrorType.ZipCodeNotFound]: $localize`Invalid ZIP code, please enter a new one`,
};
